module.exports = __webpack_public_path__ + "img/3b01e90612770a137681316b06389615-newLogo3.png";